import * as R from 'ramda'
import { CATEGORY_LABEL_MAP, categories, getPoliciesValueMap } from '@System/views/strategydefinition/config'
import { isMonitorTemplateCategory } from '@Monitor/utils/monitorTemplate'
import {
  getNameDescriptionTableColumn,
} from '@/utils/common/tableColumn'
import i18n from '@/locales'
import { getDurationLabel } from '@/utils/utils'

export default {
  created () {
    const valueMap = getPoliciesValueMap()
    this.columns = [
      getNameDescriptionTableColumn({
        onManager: this.onManager,
        edit: false,
        hideField: true,
        showDesc: false,
        field: 'policy_name',
        slotCallback: row => {
          return (
            <side-page-trigger onTrigger={() => this.handleOpenSidepage(row)}>{ row.policy_name }</side-page-trigger>
          )
        },
      }),
      {
        field: 'category',
        title: i18n.t('cloudenv.text_502'),
        formatter: ({ cellValue }) => {
          return CATEGORY_LABEL_MAP[cellValue]
        },
      },
      {
        field: 'policy',
        title: i18n.t('cloudenv.text_501'),
        width: 220,
        slots: {
          default: ({ row }) => {
            if (row.category === 'server_duration') {
              const tags = row.policy.server_duration.map(item => {
                return <a-tag class='mb-2'>{getDurationLabel(item)}</a-tag>
              })
              return [<list-body-cell-popover text={CATEGORY_LABEL_MAP[row.category] + ':' + this.$t('common_701', [row.policy.server_duration.length])} max-width="400px">
                { ...tags }
              </list-body-cell-popover>]
            }
            // 监控模板只有面板配置，直接展示配置的监控指标
            if (isMonitorTemplateCategory(row.category)) {
              const panels = (row.policy && row.policy.panels) || []
              const tags = panels.map(item => <a-tag class='mb-2'>{item.label}</a-tag>)
              return [<list-body-cell-popover text={i18n.t('monitor.resource_template.panel_count') + ':' + panels.length} max-width="400px">
                <div style="display: inline-flex; flex-wrap: wrap; max-width: 40vw;">
                  {...tags}
                </div>
              </list-body-cell-popover>]
            }
            const len = row.policy ? Object.keys(row.policy).length : 0
            let actionType = ''
            R.forEach((item) => {
              if (item.key === row.category) actionType = item.action
            }, categories)
            const ret = []
            R.forEachObjIndexed((value, key) => {
              ret.push(<a-tag class='mb-2'>{ valueMap[row.category][key] }{ value === true ? '' : '：' + value }</a-tag>)
            }, row.policy)
            return [<list-body-cell-popover text={i18n.t('cloudenv.text_557', [actionType, len])} max-width="400px">
              <div style="display: inline-flex; flex-wrap: wrap; max-width: 40vw;">
                {...ret}
              </div>
            </list-body-cell-popover>]
          },
        },
      },
      {
        field: 'scope',
        title: i18n.t('cloudenv.text_503'),
        formatter: ({ row }) => {
          let ret = i18n.t('cloudenv.text_504')
          if (row.project_domain) {
            ret = i18n.t('cloudenv.text_505', [row.project_domain])
          }
          if (row.domain_id && row.domain_id === '[any_domain_id]') {
            ret = i18n.t('cloudenv.text_573')
          }
          if (row.project) {
            ret = i18n.t('cloudenv.text_506', [row.project])
          }
          return ret
        },
      },
    ]
  },
}
